import React, {FC} from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import FacebookLoginButton from "../../components/buttons/FacebookLoginButton";
import {Locale} from "../../locales/Locale";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";

interface ILoginDialog {
    open: boolean;
    onClose: () => void;
    onLoginSuccess: (user: any) => void;
    onLoginFailure: () => void;
}

export const LoginDialog: FC<ILoginDialog> = ({
    open,
    onClose,
    onLoginSuccess,
    onLoginFailure,
}) => {

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle><Locale localeId={IdlocaGeneric.login}/></DialogTitle>
            <DialogContent>
                <FacebookLoginButton
                    onLoginSuccess={onLoginSuccess}
                    onLoginFailure={onLoginFailure}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                    sx={{
                        padding: "8px 20px",
                        borderRadius: "8px",
                        textTransform: "none",
                        backgroundColor: theme => theme.palette.button.secondary,
                        color: theme => theme.palette.button.text,
                        "&:hover": {
                            backgroundColor: theme => theme.palette.button.hover,
                        },
                    }}
                >
                    <Locale localeId={IdlocaGeneric.cancel}/>
                </Button>
            </DialogActions>
        </Dialog>
    );
};
